import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { k1Api } from "../../services/api";
import type { PortfolioComment } from "../domain/types";

export function usePortfolioComments(
  fundId: number,
  quarter: string,
  enabled = false,
) {
  const queryClient = useQueryClient();
  const queryKey = ["k1", "portfolio-comments", fundId, quarter];

  const { data: comments = [], isLoading } = useQuery({
    queryKey,
    queryFn: () => k1Api.getPortfolioComments(fundId, quarter),
    staleTime: 30_000,
    enabled: enabled && !!fundId && !!quarter,
  });

  const { mutate: post, isPending: isPosting } = useMutation({
    mutationFn: (message: string) =>
      k1Api.createPortfolioComment({ fund_id: fundId, quarter, message }),
    onSuccess: (newComment: PortfolioComment) => {
      queryClient.setQueryData<PortfolioComment[]>(queryKey, (prev = []) => [
        ...prev,
        newComment,
      ]);
      queryClient.invalidateQueries({ queryKey: ["k1", "funds-portfolio"] });
      queryClient.invalidateQueries({ queryKey: ["k1", "tracker-row"] });
    },
  });

  return { comments, isLoading, post, isPosting };
}
